module.exports = __webpack_public_path__ + "static/hchoneysticksfruity-153f3f6577c4df5aee1aebcd8264d5c1.jpg";